function parts(timestamp: number, zone: string) {
  const values = Object.fromEntries(new Intl.DateTimeFormat("en-CA", { timeZone: zone, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).formatToParts(new Date(timestamp)).map(part => [part.type, part.value]));
  return `${values.year}-${values.month}-${values.day}T${values.hour}:${values.minute}`;
}
export function zoneInput(value: string, zone: string) { return parts(Date.parse(value), zone); }
export function zoneIso(value: string, zone: string) {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(value);
  if (!match) throw new Error("Date et heure complètes requises.");
  const target = Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]), Number(match[4]), Number(match[5]));
  let guess = target;
  for (let attempt = 0; attempt < 4; attempt++) guess -= Date.parse(parts(guess, zone) + "Z") - target;
  const candidates = [-120, -90, -60, -30, 0, 30, 60, 90, 120].map(minutes => guess + minutes * 60000).filter(timestamp => parts(timestamp, zone) === value);
  if (!candidates.length) throw new Error("Cet horaire n’existe pas dans le fuseau de la compagnie.");
  return new Date(Math.min(...candidates)).toISOString();
}
